import React, { Fragment, useEffect, useRef, useState } from 'react'
import AnimateHeight from 'react-animate-height'
import _ from 'lodash'

import { isRailBookers } from '../../../configuration/brand'
import '../../../styles/scss/elements/destination-tags.scss'

const TRUNCATED_DESTINATIONS_SIZE = isRailBookers() ? 100 : 94

const DestinationTags = ({ destinations, disabled }) => {
  const tagsRef = useRef()
  const [destinationsOpen, setDestinationsOpen] = useState(false)
  const [displayDestinationToggle, setDisplayDestinationToggle] = useState(true)

  useEffect(() => {
    setTimeout(() => onWindowResize(), 250)
    window.addEventListener("resize", onWindowResize)
    return () => window.removeEventListener("resize", onWindowResize)
  }, [])

  function onWindowResize() {
    const destinationsHeight = _.get(tagsRef, 'current.offsetHeight')
    if (destinationsHeight) {
      setDisplayDestinationToggle(destinationsHeight > TRUNCATED_DESTINATIONS_SIZE)
    }
  }

  function toggleDestinations() {
    setDestinationsOpen(!destinationsOpen)
  }

  function getComponentHeight() {
    if (!displayDestinationToggle || destinationsOpen || disabled) {
      return 'auto'
    }
    return TRUNCATED_DESTINATIONS_SIZE
  }

  return (
    <div className="u-flex u-flex-column destinations-tags">
      <AnimateHeight height={getComponentHeight()}>
        <div
          className="u-flex u-flex-wrap destinations-tags__carets"
          ref={tagsRef}
        >
          {_.map(destinations, (destination, index) => (
            <Fragment key={`${index}`}>
              {index > 0 && <div />}
              <span>{destination}</span>
            </Fragment>
          ))}
        </div>
      </AnimateHeight>
      <button
        aria-label={destinationsOpen ? 'Less' : 'More'}
        className="destinations-tags__more-button"
        disabled={disabled || !displayDestinationToggle}
        onClick={toggleDestinations}
        style={{ display: disabled || !displayDestinationToggle ? 'none' : 'flex'}}
      >
        {!disabled && displayDestinationToggle
          ? destinationsOpen ? 'Less' : 'More'
          : ''}
        <span className={destinationsOpen ? 'more-toggle-open' : 'more-toggle-close'} />
      </button>
    </div>
  )
}

export default DestinationTags
